import { Chart } from 'chart.js';
import Labels from './labels';
import { createValueLabelsPlugin } from './valueLabelsPlugin';

const getClientsTypeByPeriod = (ctxId, state, tasksMap) => {
    const ctx = document.getElementById(ctxId);

    if (!ctx) {
        return
    }

    if (state.chartClientsType) {
        state.chartClientsType.destroy();
    }

    const labels = {
        daily: Labels(state.shiftPeriod).daily,
        monthly: Labels(state.shiftPeriod).monthly,
        quarterly: Labels(state.shiftPeriod).quarterly,
        yearly: Labels(state.shiftPeriod).yearly
    };

    const data = getClientTypeData(tasksMap, state);

    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels[state.period],
            datasets: [
                {
                    label: 'Nuevos',
                    data: data[state.period].new,
                    backgroundColor: 'rgba(255, 99, 132, 0.8)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 1
                },
                {
                    label: 'Recurrentes',
                    data: data[state.period].recurrent,
                    backgroundColor: 'rgba(54, 162, 235, 0.8)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1
                }
            ]
        },
        options: {
            scales: {
                xAxes: [{
                    stacked: true,
                    gridLines: {
                        color: 'rgba(200, 200, 200, 0.2)'
                    },
                    ticks: {
                        fontColor: 'black'
                    }
                }],
                yAxes: [{
                    stacked: true,
                    gridLines: {
                        color: 'rgba(200, 200, 200, 0.2)'
                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: 'black'
                    }
                }]
            },
            legend: {
                labels: {
                    fontColor: 'black'
                }
            },
            tooltips: {
                enabled: false
            },
        },
        plugins: [createValueLabelsPlugin({
            format: (v) => `${Number(v)}`
        })]
    });

    return chart;
}

const getClientTypeData = (tasksMap, state) => {
    // Convertir tasksMap a array de tareas y ordenar por fecha
    const tasks = Object.values(tasksMap || {})
        .filter(task => task.dateEntry)
        .sort((a, b) => a.dateEntry - b.dateEntry);

    // Inicializar estructuras para cada período
    const dailyData = {};
    const monthlyData = {};
    const quarterlyData = {};
    const yearlyData = {};

    Labels(state.shiftPeriod).dailyIds.forEach(id => {
        dailyData[id] = { new: 0, recurrent: 0 };
    });

    Labels(state.shiftPeriod).monthlyIds.forEach(id => {
        monthlyData[id] = { new: 0, recurrent: 0 };
    });

    Labels(state.shiftPeriod).quarterlyIds.forEach(id => {
        quarterlyData[id] = { new: 0, recurrent: 0 };
    });

    Labels(state.shiftPeriod).yearlyIds.forEach(id => {
        yearlyData[id] = { new: 0, recurrent: 0 };
    });

    // Mapa para rastrear la primera aparición de cada cliente (por DNI)
    const clientFirstAppearance = {};

    // Procesar cada tarea en orden cronológico
    tasks.forEach(task => {
        if (!task.dateEntry || !task.dni) return;

        const dateEntry = new Date(task.dateEntry);
        const day = dateEntry.getDate();
        const month = dateEntry.getMonth() + 1;
        const year = dateEntry.getFullYear();

        // Determinar si es cliente nuevo
        // Un cliente es nuevo si esta es la primera tarea con ese DNI
        let isNewClient = false;
        
        if (!clientFirstAppearance[task.dni]) {
            // Primera vez que vemos este DNI
            isNewClient = true;
            clientFirstAppearance[task.dni] = task.dateEntry;
        }

        // Claves para cada período
        const dailyKey = `${day}-${month}-${year}`;
        const monthlyKey = `${month}-${year}`;
        const quarterlyKey = `Q${Math.floor((month - 1) / 3) + 1}-${year}`;
        const yearlyKey = `${year}`;

        // Actualizar datos diarios
        if (dailyData[dailyKey] !== undefined) {
            if (isNewClient) {
                dailyData[dailyKey].new += 1;
            } else {
                dailyData[dailyKey].recurrent += 1;
            }
        }

        // Actualizar datos mensuales
        if (monthlyData[monthlyKey] !== undefined) {
            if (isNewClient) {
                monthlyData[monthlyKey].new += 1;
            } else {
                monthlyData[monthlyKey].recurrent += 1;
            }
        }

        // Actualizar datos trimestrales
        if (quarterlyData[quarterlyKey] !== undefined) {
            if (isNewClient) {
                quarterlyData[quarterlyKey].new += 1;
            } else {
                quarterlyData[quarterlyKey].recurrent += 1;
            }
        }

        // Actualizar datos anuales
        if (yearlyData[yearlyKey] !== undefined) {
            if (isNewClient) {
                yearlyData[yearlyKey].new += 1;
            } else {
                yearlyData[yearlyKey].recurrent += 1;
            }
        }
    });

    // Convertir a arrays en el orden correcto
    const dailyValues = Labels(state.shiftPeriod).dailyIds.map(id => dailyData[id]);
    const monthlyValues = Labels(state.shiftPeriod).monthlyIds.map(id => monthlyData[id]);
    const quarterlyValues = Labels(state.shiftPeriod).quarterlyIds.map(id => quarterlyData[id]);
    const yearlyValues = Labels(state.shiftPeriod).yearlyIds.map(id => yearlyData[id]);

    return {
        daily: {
            new: dailyValues.map(v => v.new),
            recurrent: dailyValues.map(v => v.recurrent)
        },
        monthly: {
            new: monthlyValues.map(v => v.new),
            recurrent: monthlyValues.map(v => v.recurrent)
        },
        quarterly: {
            new: quarterlyValues.map(v => v.new),
            recurrent: quarterlyValues.map(v => v.recurrent)
        },
        yearly: {
            new: yearlyValues.map(v => v.new),
            recurrent: yearlyValues.map(v => v.recurrent)
        }
    };
}

export default getClientsTypeByPeriod;